module.exports = "/1/4-bien-va-cac-kieu-du-lieu-trong-c/index.html.13c577638c6f91eda9b5863c77255544.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/29935.md
 ** module id = 533
 ** module chunks = 0
 **/